<template>
  <div class="app-container">
    <div class="info-box">
      <div class="left-box" v-if="!isMB">
        <div class="topSelect">
          学期名称：
          <el-select v-model="TermId" @change="termChange" size="small" class="tselect">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
          <!-- <el-button icon="el-icon-caret-top" type="text" style="padding:7px;margin-left:20px;" v-if="isMB" @click="showTree=false">收起</el-button> -->
        </div>
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有班级</span>
          <!-- <el-button type="text" @click="createTree" icon="el-icon-circle-plus-outline"></el-button> -->
        </div>
        <div class="left-main">
          <teach-tree ref="teachTree" @on-select="onSelect" @on-pselect="onPselect"></teach-tree>
        </div>
      </div>
      <div class="main-box">
        <list ref="list" :canSearch="canSearch" @setadd="setcanAdd">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button size="mini" type="success" plain @click="importTeach" v-if="!isMB">导入任课信息</el-button>
            <el-button size="mini" type="primary" plain @click="exportTeach" v-if="!isMB">导出</el-button>
            <el-button
              :disabled="!canAdd"
              size="mini"
              type="primary"
              @click="create"
            >添加</el-button>
            <el-button size="mini" type="danger" @click="delRows">删除</el-button>
            <!-- <el-button size="mini" type="success" @click="showTree=true" style="margin:0px 0 0 10px;" v-if="isMB">筛选</el-button> -->
          </template>
          <template slot="column">
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              :width="isMB?65:80"
              v-if="$permission.canWrite()"
            >
              <template slot-scope="{row}">
                <el-button type="text" @click="editById(row.TeachersTeachingId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="toReload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="toReload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/ed/teach/list";
import editDialog from "@/components/ed/teach/editDialog";
import teachTree from "@/components/ed/teach/teachTree/tree";
import termApi from "@/api/ed/term";
import importDialog from "@/components/ed/teach/importDialog";

export default {
  name: "teach",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    teachTree,
    importDialog,
  },
  data() {
    return {
      data: {
        ClassId: null,
        ClassName: "",
        GradIde: null,
      },
      termApi,
      TermId: null,
      TermName: "",
      TermNumber: "",
      termList: [],
      canSearch: true,
      canAdd: false,
      isMB: this.$store.state.isMB,
      // showTree: !this.$store.state.isMB,
    };
  },
  mounted() {
    if (!this.isMB) {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        if (res.Data.length > 0) {
          let tid = res.Data[0].TermId;
          this.TermId = tid;
          this.TermName = res.Data[0].TermName;
          this.TermNumber = res.Data[0].TermNumber;
          this.$refs.teachTree.getData(tid);
          this.$refs.list.TermId = tid;
          this.$refs.list.getData({ TermId: tid });
          sessionStorage.setItem("termId", tid);
        }
      });
    }
  },
  methods: {
    importTeach() {
      this.$refs.importDialog.TermId = this.TermId;
      // this.$refs.importDialog.TermNumber = this.TermNumber
      this.$refs.importDialog.TermName = this.TermName;
      this.$refs.importDialog.open();
    },
    exportTeach() {
      this.$refs.list.export({
        TermId: this.TermId,
        ClassId: this.data.ClassId,
      });
    },
    termChange(e) {
      this.canAdd = false;
      this.$refs.teachTree.getData(e);
      sessionStorage.setItem("termId", e);
      this.$refs.list.TermId = e;
      this.$refs.list.query({ TermId: e });
      this.termList.forEach((item) => {
        if (e == item.TermId) {
          this.TermNumber = item.TermNumber;
          this.TermName = item.TermName;
        }
      });
    },
    toReload() {
      this.$refs.list.reload();
      // if(this.data.ClassId) {
      //   this.$refs.list.query({TermId: this.TermId, ClassId: this.data.ClassId})
      // } else if(this.GradeId) {
      //   this.$refs.list.query({TermId: this.TermId, GradeId: this.data.GradeId })
      // } else {
      //   this.$refs.list.query({TermId: this.TermId })
      // }
    },
    reload() {},
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ TermId: this.TermId });
      console.log("allData", this.data);
      this.canAdd = false;
    },
    resetSelect() {
      this.$refs.teachTree.resetSelect();
      this.data.ClassId = null;
      this.data.ClassName = "";
    },
    onSelect(data) {
      console.log("onSelect", data);
      if (this.data.ClassId != data.ClassId) {
        this.data.ClassId = data.ClassId;
        this.data.ClassName = data.ClassName;
        this.$refs.list.getData({ ClassId: data.ClassId, TermId: this.TermId });
        this.canAdd = true;
      }
    },
    onPselect(data) {
      if (this.data.GradeId != data.GradeId) {
        this.data.ClassId = null;
        this.$refs.list.getData({ TermId: this.TermId, GradeId: data.GradeId });
        this.canAdd = false;
      }
    },
    createTree() {
      this.$refs.teachTree.create();
    },
    create() {
      this.$refs.editDialog.openCreate(this.data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.TeachersTeachingId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    setcanAdd(e) {
      this.canAdd = e;
    },
  },
};
</script>
<style lang="less" scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.left-box {
  width: 250px;
  min-width: 250px;
  border: 1px solid #e4e7ed;
  .left-title {
    padding-left: 25px;
    color: #606266;
    background-color: #ebeef5;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    line-height: 40px;
    padding-right: 8px;
    .el-button--text {
      font-size: 18px;
    }
  }
  .left-main {
    height: calc(100% - 40px);
    overflow: auto;
  }
}
.mbLB {
  z-index: 5;
  background-color: #fff;
  position: fixed;
  top: -100%;
  width: 100%;
  transition-duration: 0.5s;
  left: 0;
  padding-top: 10px;
  margin-top: -10px;
  max-height: 90%;
  padding-bottom: 30px;
  overflow: auto;
}
.showLB {
  top: 14%;
}
.main-box {
  width: 100%;
  overflow: auto;
  @media screen and (min-width: 768px) {
    margin-left: 10px;
    padding: 10px;
    border: 1px solid #e4e7ed;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.footer {
  border-top: 1px solid #e4e7ed;
  padding: 10px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 50px 20px 0px 20px;
  @media screen and (max-width: 767px) {
    margin-top: 10px;
  }
  .el-button {
    width: 80px;
  }
}
.image-slot {
  font-size: 36px;
  color: #909399;
  position: absolute;
  top: 50%;
  left: 50%;
  /* 这里有兼容性问题 */
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.avatar {
  height: 100%;
  display: block;
}
.topSelect {
  text-align: center;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  .tselect {
    width: 150px;
    @media screen and (min-width: 768px) {
      float: right;
    }
  }
  /deep/ .el-input__inner {
    border-radius: 0px !important;
  }
}
</style>